import type { FetchResponse } from '@sydle/ui-api';
import { portalCustomAPI } from '.';
import type { CatalogNode } from '../models/CatalogNode';
import type { PortalLinkCardConfig } from '../models/portal/PortalLinkCardConfig';

export interface GetChildrenInput {
  id: string;
  application: string;
  linkConfig?: PortalLinkCardConfig;
  keepParent?: boolean;
  size?: number;
  rootId?: string;
  path?: string;
  params?: any;
  view?: string;
  query?: any;
  allLang?: string[];
  returnFields?: string[];
  returnParentFields?: string[];
  searchConfig?: any;
}

type Children = Omit<CatalogNode, '_class' | 'displayMode' | 'linkedParents' | 'tags'>;

export interface GetChildrenOutput {
  hits?: number;
  return?: Children[];
}

export async function getChildren(input: GetChildrenInput): Promise<FetchResponse<GetChildrenOutput>> {
  return await portalCustomAPI.fetch<GetChildrenInput, GetChildrenOutput>('getChildren', input);
}
